module.exports = __webpack_public_path__ + "img/Cert 11.5a4853f3.png";